import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-astlabs',
  templateUrl: './astlabs.component.html',
  styleUrls: ['./astlabs.component.scss']
})
export class AstlabsComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
